module.exports = __webpack_public_path__ + "img/tt.67c169ac.svg";